import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Ball = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "none",
    d: "M7.775 19.396c2.471 0 5.954-.539 8.518-3.103 3.77-3.77 3.171-9.568 2.854-11.445a17.675 17.675 0 00-2.955-.25c-2.464 0-5.938.538-8.495 3.099-3.773 3.78-3.166 9.578-2.847 11.454.622.106 1.67.245 2.925.245zm.933-9.104l1.793 1.794 1.585-1.586-1.794-1.793 1.414-1.414L13.5 9.086l1.793-1.793 1.414 1.414-1.793 1.793 1.793 1.792-1.414 1.414-1.793-1.792-1.586 1.586 1.792 1.793-1.415 1.414-1.791-1.792-1.792 1.792-1.414-1.414L9.086 13.5l-1.793-1.794 1.415-1.414z",
    key: "k0"
  }), React.createElement("path", {
    d: "M3.757 20.97c.069.018 1.726.426 4.018.426 2.849 0 6.884-.641 9.932-3.688 5.335-5.335 3.351-13.6 3.264-13.949a1 1 0 00-.727-.729c-.069-.018-1.742-.433-4.052-.433-2.842 0-6.869.64-9.91 3.687-5.339 5.349-3.34 13.61-3.252 13.96.09.358.369.637.727.726zM7.698 7.696c2.557-2.561 6.031-3.099 8.495-3.099 1.27 0 2.33.142 2.955.25.316 1.877.915 7.676-2.854 11.445-2.564 2.563-6.047 3.103-8.518 3.103-1.255 0-2.303-.139-2.924-.245-.32-1.876-.927-7.673 2.846-11.454z",
    key: "k1"
  }), React.createElement("path", {
    d: "M7.293 15.293l1.414 1.414 1.793-1.792 1.791 1.792 1.415-1.414-1.792-1.793 1.586-1.586 1.793 1.792 1.414-1.414-1.793-1.792 1.793-1.793-1.414-1.414L13.5 9.086l-1.794-1.793-1.414 1.414 1.794 1.793-1.586 1.586-1.792-1.794-1.416 1.414L9.086 13.5z",
    key: "k2"
  }));
});
Ball.displayName = 'Ball';
export var BallDimensions = {
  height: 24,
  width: 24
};